import React from 'react';

export const SVGCollapse: React.FC = () => {
    return (
        <div className="svg-icon collapse-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19.714 10.286H4.286c-.71 0-1.286.575-1.286 1.285v1.286c0 .71.576 1.286 1.286 1.286h15.428c.71 0 1.286-.576 1.286-1.286v-1.286c0-.71-.576-1.285-1.286-1.285z" fill="currentColor"/></svg>
        </div>
    );
}
